(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/seo-articles/assets/javascripts/seo-articles.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/seo-articles/assets/javascripts/seo-articles.js');
"use strict";


const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect;
const NavContext = svs.oddset_kambi.components.nav_context.NavContext;
const cmsArticles = svs.oddset_kambi.data.cmsArticles;
const getSeoArticles = svs.oddset_kambi.components.seo_articles.getSeoArticles.getSeoArticles;
const SeoArticles = () => {
  const _useContext = useContext(NavContext),
    windowLocationPathname = _useContext.windowLocationPathname;
  const articles = getSeoArticles(cmsArticles, windowLocationPathname);
  useEffect(() => {
    const serverArticlesSection = document.querySelector('#seo-articles-rendered-from-server');
    if (serverArticlesSection) {
      serverArticlesSection.remove();
    }
  }, []);
  return React.createElement("section", {
    className: "seo-widget-articles f-content",
    id: "seo-articles-rendered-from-client"
  }, articles.map(_ref => {
    let article = _ref.article;
    return React.createElement("article", {
      dangerouslySetInnerHTML: {
        __html: article.body
      },
      key: JSON.stringify(article)
    });
  }));
};
setGlobal('svs.oddset_kambi.components.seo_articles.SeoArticles', SeoArticles);

 })(window);